export enum AveragingTypeEnum {
    None = 0,
    Rolling = 1,
    Fixed = 2,
}
